// extracted by mini-css-extract-plugin
module.exports = {"subscriptionContainer":"newsletter-subscription_subscriptionContainer__MELlp","top":"newsletter-subscription_top__CvxoJ"};